module.exports = __webpack_public_path__ + "img/icon_historial_procesando.bb0cc21d.svg";